export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Pour que votre technologie de caméras reste fiable dans la durée',
      lead: 'SSG Care est notre abonnement de maintenance et d’accompagnement. Après l’installation, vous pouvez faire suivre votre système par un contrat Care flexible, moyennant une redevance mensuelle et une durée convenue.',
    },
    abo: {
      title: 'Modèle d’abonnement à durée flexible',
      lead: 'L’installation est facturée une fois. L’accompagnement continu se fait par abonnement mensuel, résiliable ou avec durée minimale convenue.',
      items: {
        '0': { title: 'Accompagnement mensuel', desc: 'Choisissez entre résiliation mensuelle ou durée fixe (ex. 12 ou 24 mois) avec les conditions correspondantes.' },
        '1': { title: 'Périmètre individuel', desc: 'Tous les systèmes n’ont pas besoin de tout. Nous définissons ensemble les services de votre contrat Care – évolutif et adaptable.' },
        '2': { title: 'Aucun coût caché', desc: 'Redevance mensuelle transparente. Les services hors contrat sont convenus à l’avance et facturés séparément.' },
      },
    },
    pricing: {
      eyebrow: 'Formules',
      title: 'Choisissez votre formule Care',
      lead: 'Tous les prix sont indicatifs. La redevance finale dépend de la taille, du périmètre et de la durée.',
      featured: 'Choix le plus populaire',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Pour petits systèmes', price: 'dès 19 €/mois', features: { '0': 'Contrôle trimestriel (à distance)', '1': 'Gestion des mises à jour du firmware', '2': 'Support app par téléphone/email', '3': 'Demandes prioritaires' } },
        '1': { name: 'Care Professional', subtitle: 'Pour systèmes professionnels', price: 'dès 39 €/mois', features: { '0': 'Contrôle mensuel (à distance)', '1': 'Mises à jour du firmware et correctifs', '2': 'Gestion des utilisateurs et droits', '3': 'Contrôle stockage et enregistrement', '4': 'Aide au changement de smartphone', '5': 'Intervention sur site sur accord', '6': 'Traitement prioritaire' } },
        '2': { name: 'Care Enterprise', subtitle: 'Pour multi-sites et grands projets', price: 'Sur mesure', features: { '0': 'Contrôle hebdomadaire (à distance)', '1': 'Tous les services Professional', '2': 'Interlocuteur dédié', '3': 'Conseils d’extension proactifs', '4': 'Rendez-vous sur site réguliers', '5': 'Documentation et reporting' } },
      },
    },
    services: {
      title: 'Ce que SSG Care peut faire pour vous',
      items: {
        '0': { title: 'Contrôles réguliers', desc: 'Contrôle de la fonction, de l’enregistrement et du réseau, à distance ou sur site selon la formule.' },
        '1': { title: 'Mises à jour du firmware', desc: 'Vérification et exécution des mises à jour convenues selon le fabricant.' },
        '2': { title: 'Support app et accès', desc: 'Aide pour les problèmes d’app, d’accès et le changement de smartphone ou la réinstallation.' },
        '3': { title: 'Gestion des utilisateurs et droits', desc: 'Gestion des accès, nouveaux utilisateurs et changements de droits.' },
        '4': { title: 'Enregistrement et stockage', desc: 'Contrôle de l’occupation, de la qualité d’enregistrement et des sauvegardes.' },
        '5': { title: 'Support à distance', desc: 'Accès à distance pour diagnostic et configuration, si possible et souhaité.' },
      },
    },
    form: {
      title: 'Votre offre Care personnelle',
      lead: 'Dites-nous quel accompagnement vous envisagez. Nous vous répondrons avec une proposition individuelle incluant durée et redevance.',
      customerType: 'Type de client',
      select: 'Veuillez choisir',
      privat: 'Particulier',
      gewerbe: 'Professionnel',
      locations: 'Nombre de sites',
      locations1: '1 site',
      locations2: '2–3 sites',
      locations3: '4 et plus',
      cameraCount: 'Nombre approximatif de caméras',
      cameras1: '1–2 caméras',
      cameras2: '3–6 caméras',
      cameras3: '7–12 caméras',
      cameras4: '13 et plus',
      systemStatus: 'État du système',
      statusNew: 'Nouveau système',
      statusExisting: 'Système existant',
      statusExtension: 'Extension prévue',
      contractTerm: 'Durée de contrat souhaitée',
      termOpen: 'Ouvert / à convenir',
      termMonthly: 'Résiliation mensuelle',
      term12: '12 mois',
      term24: '24 mois',
      term36: '36 mois',
      name: 'Nom *',
      email: 'Email *',
      phone: 'Téléphone',
      company: 'Entreprise',
      message: 'Informations complémentaires',
      maxChars: 'Maximum 500 caractères',
      consent: 'J’ai lu la politique de confidentialité et j’accepte le traitement de mes données pour cette demande. *',
      success: 'Merci pour votre demande. Nous vous répondrons bientôt avec votre offre Care individuelle.',
      submit: 'Envoyer la demande Care',
      submitting: 'Envoi...',
    },
  },
};